import TripodUtilService from "./TripodUtilService";
import AppConfiguration from "../dataProvider/config";
import axios from "axios";
import { get } from "lodash";

let ghtkTokenStr = localStorage.getItem("ghtk-token-storage");

const requestHeader = {
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
  "Access-Control-Allow-Headers":
    "Origin,Authorization,Content-Type,Accept,User-Agent,Cache-Control,Keep-Alive,X-Requested-With,If-Modified-Since",
  timeout: 180000,
};
if (ghtkTokenStr) {
  let ghtkTokenStorage = JSON.parse(ghtkTokenStr);
  let accessToken = get(ghtkTokenStorage, "accessToken.accessToken", "");
  if (accessToken) {
    requestHeader["Authorization"] = `Bearer ${accessToken}`;
  }
}
const axiosConfig = {
  baseURL: AppConfiguration.apiBaseTripod,
  headers: requestHeader,
};

const axiosInstance = axios.create(axiosConfig);

const TripodService = new TripodUtilService();

export default {
  // tripod list
  getTripodsFilterData() {
    let api = `/v1/tripod/info/filter-data`;
    return TripodService.get(api);
  },
  getListTripod(param) {
    let api = `/v1/tripod/info`;
    return TripodService.get(api, { params: param });
  },
  //Create tripod
  createTripod(data) {
    let api = `/v1/tripod/info`;
    return axiosInstance.post(api, data);
  },
  //Update tripod
  updateTripod(param, id) {
    let api = `/v1/tripod/info/${id}`;
    return axiosInstance.put(api, param);
  },
  //delete tripod
  deleteTripod(id) {
    let api = `/v1/tripod/info/${id}`;
    return axiosInstance.delete(api);
  },
  // tripod log
  getTripodLogFilterData() {
    let api = `/v1/tripod/log/filter-data`;
    return TripodService.get(api);
  },
  getTripodLogListData(param) {
    let api = `/v1/tripod/log`;
    return TripodService.get(api, { params: param });
  },

  // tripod daily log
  getTripodDailyLogFilterData() {
    let api = `/v1/tripod/daily-log/filter-data`;
    return TripodService.get(api);
  },
  getTripodDailyLogListData(param) {
    let api = `/v1/tripod/daily-log`;
    return TripodService.get(api, { params: param });
  },
};
